<template>
  <div class="bg-gray-100 py-36 flex flex-col items-center justify-center">
    <h2 class="text-4xl">RUTA NO ENCONTRADA</h2>
  </div>
</template>
